import React, { useState, useEffect }  from 'react';
import PropTypes from 'prop-types';

import Image from './image';
import Button from '../../elements/Button'; 
import Point from '../../elements/Point'; 
import './style.scss';



function DigitalChecks(props) {
  // Wrap window.innerWidth into a function so the gatsby fix 
  // can be applied (references to window fail to resolve during
  // gatsby builds)
  const getWindowWidth = () => {
    if (typeof window !== 'undefined') {
      return window.innerWidth;
    }
  }

  const { title, description, points, image } = props; 

  const [width, setWidth] = useState(getWindowWidth()); 

  const updateWindowWidth = () => {
    setWidth(getWindowWidth());   
  }

  useEffect(() => {
    window.addEventListener('resize', updateWindowWidth); 
  }, []); 

  const getRightOffset = () => {
    let offset; 
    if (width < 1920) { 
      offset =  {};
    } else {
      offset = {
        "right": ((width - 1920)/2 - 310).toString() + "px" 
      } 
    } 
    return offset;
  }

  return (
    <div className="digital-checks-container">
      <div className="digital-checks row g-0 align-items-center">
        <div className="text-panel col-xl-6 row g-0"> 
          <div className="text-panel-upper col-lg-6 pe-lg-5 col-xl-12"> 
            <h2>{title}</h2>  
            { description.map((text, i) => {
              return (
                <p key={text.paragraph} className="segment-text">{text.paragraph}</p> 
              )
            })}
          </div> 
          { points.map((point, i) => {
            return (
              <Point
                key={point.text}
                className="point col-md-6 col-lg-3 col-xl-6"
                image={point.image} 
                header={point.header}
                text={point.text}
                button={point.button} 
                option="transparent"
              /> 
            )
          })} 
        </div> 
        <div className="image-panel col-xl-6"> 
          <Image className="api" src={image} alt="api" /> 
        </div> 
      </div> 
    </div>
  );
}

DigitalChecks.propTypes = {
  title: PropTypes.string.isRequired, 
  description: PropTypes.array.isRequired, 
  points: PropTypes.array.isRequired, 
  image: PropTypes.string.isRequired
};

export default DigitalChecks;


